import PropTypes from 'prop-types';

/**
 * WarningMessage - A reusable component to display warning messages with custom styling
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - The content to be displayed inside the warning message
 * @param {string} [props.className] - Additional CSS classes to apply to the component
 * @returns {JSX.Element} The rendered WarningMessage component
 */
const WarningMessage = ({ children, className = '' }) => {
  return (
    <div
      className={`p-3 bg-yellow-50 border border-yellow-800 rounded-md ${className}`}
    >
      <div className="text-sm text-yellow-800">{children}</div>
    </div>
  );
};

WarningMessage.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

WarningMessage.displayName = 'WarningMessage';

export default WarningMessage;
